/* eslint-disable react/forbid-prop-types */
import PropTypes from 'prop-types';

import ControllersGroup from '../../../controllers/ControllersGroup';
import {
  InputLineController,
  SelectController,
  ChoiceBoxController,
  SimpleColorPickerController,
  ToggleSwitchController,
  MultiSelectController,
} from '../../../controllers/Base';

import fontOptions from '../../../utils/controllersUtils/options';

const LabelControllers = ({
  data,
  handle,
  config,
  extend,
  setExtend,
  isGlobalThemeActive,
  isGlobalFontActive,
}) => (
  <>
    <ControllersGroup title="Rótulos" id="label" extend={extend} setExtend={setExtend}>
      <SelectController
        label="Fonte"
        handle={handle}
        kWord="LabelsFontFamilyControl"
        options={fontOptions}
        configValue={config?.LabelsFontFamilyControl?.value}
        text="Utilizando fonte global"
        disabled={(
          config?.UseGlobalFont !== false && isGlobalFontActive
        )}
      />
      <InputLineController
        label="Tamanho"
        handle={handle}
        kWord="LabelsFontSizeControl"
        configValue={config?.LabelsFontSizeControl?.value}
        min={1}
        max={30}
        step={1}
        precision={0}
        isNumber
      />
      <MultiSelectController
        label="Alinhar à esquerda"
        handle={handle}
        kWord="LabelAlignLeft"
        options={data?.columns?.map((col) => (
          { value: col, label: col, id: col }
        )).filter((col) => !(config?.LabelAlignRight ?? []).includes(col.value))}
        configValue={config?.LabelAlignLeft ?? []}
        fullWidth
      />
      <MultiSelectController
        label="Alinhar à direita"
        handle={handle}
        kWord="LabelAlignRight"
        options={data?.columns?.map((col) => (
          { value: col, label: col, id: col }
        )).filter((col) => !(config?.LabelAlignLeft ?? []).includes(col.value))}
        configValue={config?.LabelAlignRight ?? []}
        fullWidth
      />
      <ChoiceBoxController
        label="Cor das linhas"
        handle={handle}
        kWord="LineColorControl"
        options={[
          { value: 'single', label: 'Cor única', id: 'single' },
          { value: 'striped', label: 'Intercalada', id: 'striped' },
        ]}
        configValue={config?.LineColorControl || 'single'}
        fullWidth
        text="Utilizando tema global"
        disabled={config?.UseGlobalColor !== false && isGlobalThemeActive}
      />
      <SimpleColorPickerController
        label="Primária"
        handle={handle}
        kWord="RowColor"
        configValue={config?.RowColor || 'white'}
        orientation="row"
        fullWidth={config?.LineColorControl !== 'striped'}
        text="Utilizando tema global"
        disabled={config?.UseGlobalColor !== false && isGlobalThemeActive}
      />
      {config?.LineColorControl === 'striped' && (
        <SimpleColorPickerController
          label="Secundária"
          handle={handle}
          kWord="StripedRowsColor"
          configValue={config?.StripedRowsColor || 'white'}
          orientation="row"
          text="Utilizando tema global"
          disabled={config?.UseGlobalColor !== false && isGlobalThemeActive}
        />
      )}
      <SimpleColorPickerController
        label="Cor do cabeçalho"
        handle={handle}
        kWord="HeaderColor"
        configValue={config?.HeaderColor || 'white'}
        orientation="row"
        fullWidth
        text="Utilizando tema global"
        disabled={config?.UseGlobalColor !== false && isGlobalThemeActive}
      />
      <ChoiceBoxController
        label="Formatação dos valores"
        handle={handle}
        kWord="ValueFormatControl"
        options={[
          { value: 'locale', label: 'Localizada', id: 'locale' },
          { value: 'default', label: 'Valor original', id: 'default' },
        ]}
        configValue={config?.ValueFormatControl ?? 'locale'}
        fullWidth
      />
      <ToggleSwitchController
        label="Utilizar tema global"
        handle={handle}
        kWord="UseGlobalColor"
        configValue={config?.UseGlobalColor}
        firstOption=""
        secondOption=""
        fullWidth
      />
      <ToggleSwitchController
        label="Utilizar fonte global"
        handle={handle}
        kWord="UseGlobalFont"
        configValue={config?.UseGlobalFont}
        firstOption=""
        secondOption=""
        fullWidth
      />
    </ControllersGroup>
  </>
);

LabelControllers.propTypes = {
  config: PropTypes.objectOf(PropTypes.any),
  data: PropTypes.objectOf(PropTypes.any),
  handle: PropTypes.func,
  extend: PropTypes.string,
  setExtend: PropTypes.func,
  isGlobalThemeActive: PropTypes.bool,
  isGlobalFontActive: PropTypes.bool,
};

export default LabelControllers;
